<template>
<div class="h-full w-full flex flex-col">
    <div class="h-full w-full">
        <div class="w-full text-base border-b p-1 my-2 tracking-widest">
            File Attachments 
        </div>
        <div class="grid grid-cols-4 gap-2">
        
        <div class="flex flex-col justify-end h-full">
            <button
                    @click.prevent="showAddFileForm"
                    class="rounded-lg px-2 py-1  flex space-x-1 text-white justify-center items-center bg-dark-primary hover:bg-dark-secondary"
                >
                <div class="tracking-normal">
                    Attach Files
                </div>
            </button>
        
        <base-modal
            v-if="visibleAddFileForm"
            :show-modal-menu-button="false"
            :is-form-visible="visibleAddFileForm"
            @close="hideAddFileForm"
        >
            <template #header>
                <div class="text-xl text-primary-extra-dark">
                    Upload File Attachments
                </div>
            </template>
            <template #body>
                <DropboxUploader @upload-file-attachments="uploadFiles"/>
            </template>
        </base-modal>
        </div>
        <div class="flex items-center space-y-2 col-span-4">
            <div class="w-full grid grid-cols-4 max-w-[1000px]">
                <ExistingDropboxFileThumbnail
                    v-for="file in tempFiles" 
                    :key="getFileId(file)" 
                    :file="file"
                />
            </div>
        </div>
        </div>
    </div>
    <div class="flex w-full justify-center items-center">
        <base-button-affirmative @click="submitForm" class="mx-1">Save</base-button-affirmative>
        <base-button-negative class="mx-1" @click.prevent="cancel">Cancel</base-button-negative>

    </div>
</div>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits, computed, reactive } from 'vue';
import DropboxUploader from '../base-components/DropboxUploader.vue';
import ExistingDropboxFileThumbnail from '../base-components/ExistingDropboxFileThumbnail.vue';


const props = defineProps(['inventoryItem'])
const emit = defineEmits(['submit-form', 'cancel'])

const visibleAddFileForm = ref(false)

function showAddFileForm(){
    visibleAddFileForm.value = true
}

function cancel(){
    emit('cancel')
}

function hideAddFileForm(){
    visibleAddFileForm.value = false
}

const formData = reactive({
    file_attachments: props.inventoryItem.file_attachments
})

const tempFiles = computed(() => {
    return formData.file_attachments
})

function getFileId(file) {
    if(file._id) {
        return file._id
    } else {
        return file.link
    }
}


function submitForm(){
    emit('submit-form', formData)
}
function removeTempFile(id) {
    console.log('remove temp file')
    const tempFileIndex = formData.file_attachments.findIndex((file) => {
        return file._id == id
    })
    if(tempFileIndex > -1){
        formData.file_attachments.splice(tempFileIndex, 1)
    }
}



function uploadFiles(attachments) {
    console.log('atachments', attachments)
    attachments.forEach((attachment) => {
        formData.file_attachments.push(attachment)
    })
    hideAddFileForm()
}

</script>